<template>
  <div
    v-if="$root.mode === 'lg' || $root.mode === 'xl'"
    v-bind:class="[
      `-${$root.site}`,
      { 'utility-black': !showLinks, utility: showLinks },
    ]"
  >
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="items">
            <!-- <div
              class="back-link tooltipHome homeicon"
              :class="siteRegion"
              v-if="siteRegion !== 'en-gb'"
            >
              <a
                :href="data[0].href"
                :target="data[0].target"
                class="prev"
                v-if="data[0] !== undefined"
                v-tooltip="{
                  content: 'Back to Home',
                  classes: ['tooltipQualityAssistant'],
                }"
              > -->
            <!-- {{ data[0].name }} -->

            <!-- <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 23.6 26"
                  class="home-icon"
                >
                  <g
                    id="Icon_feather-home"
                    data-name="Icon feather-home"
                    transform="translate(-3.5 -2)"
                  >
                    <path
                      id="Path_55"
                      data-name="Path 55"
                      d="M4.5,11.4,15.3,3l10.8,8.4V24.6A2.4,2.4,0,0,1,23.7,27H6.9a2.4,2.4,0,0,1-2.4-2.4Z"
                      fill="none"
                      stroke="#e0dede"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                    <path
                      id="Path_56"
                      data-name="Path 56"
                      d="M13.5,30V18h7.2V30"
                      transform="translate(-1.8 -3)"
                      fill="none"
                      stroke="#e0dede"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                    <path
                      id="Path_82"
                      data-name="Path 82"
                      d="M13.5,30V18h7.2V30"
                      transform="translate(-1.8 -3)"
                      fill="none"
                      stroke="#e0dede"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                    />
                  </g>
                </svg>
              </a>
            </div> -->
            <div class="product-links-wrapper" v-if="data[1] !== undefined">
              <!-- <ul class="product-links" v-if ="showLinks"> -->
              <ul class="product-links flex-wrap">
                <li class="mr-0 ml-2 text-white" v-if="data[1]">
                  <!-- {{ data[1].name }}  -->
                </li>
                <li
                  class="m-0 textlengthupdate"
                  v-if="data[1]"
                  v-for="(item, i) in data[1].children"
                >
                  <a
                    v-bind:href="item.href"
                    class="mr-1 ml-1"
                    v-if="ignorePhilips(item)"
                    :class="
                      item.description === 'philips-recall'
                        ? 'bg-red'
                        : item.description === 'uk-only-link'
                        ? 'uk-only-link'
                        : ''
                    "
                    :target="item.target"
                    >{{ item.name }}</a
                  >
                  <!-- <span
                    class="text-white"
                    v-if="i < data[1].children.length - 1"
                    >|</span
                  > -->
                </li>
              </ul>
            </div>

            <div class="menu-wrapper">
              <ul class="menu">
                <li
                  v-if="
                    username !== null && technicalApproved && technicalEmail
                  "
                  v-tooltip="{
                    content: $getTranslation(
                      'Quality Assistant',
                      $route.params.region
                    ),
                    classes: ['tooltipQualityAssistant'],
                  }"
                  class="qualityiconli"
                >
                  <a
                    href="http://quality.resmedglobal.com/"
                    target="_blank"
                    class="quality-icon"
                  >
                    <img
                      class="help-icon"
                      src="@/assets/images/HelpIcon.png"
                      :alt="
                        $getTranslation(
                          'Quality Assistant',
                          $route.params.region
                        )
                      "
                    />
                  </a>
                </li>
                <li
                  v-on:click="
                    username !== null
                      ? (menuClicked = !menuClicked)
                      : redirectNotLoggedInUser()
                  "
                  v-tooltip="{
                    content: tooltipContent,
                    classes: ['tooltipusericon'],
                    hide: true,
                  }"
                  v-close-popover="true"
                  class="float-right usericonli"
                >
                  <a href="#" v-if="usericon == '0'">
                    <!-- src="@/assets/images/loginicon.png" -->
                    <img
                      src="@/assets/images/userlogin.png"
                      alt="Welcome User"
                      class="img-fluid profile-picture ml-auto"
                      style="filter: invert(100%)"
                  /></a>
                  <a href="#" v-else>
                    <img
                      src="@/assets/images/user-profile.png"
                      alt="Welcome User"
                      class="img-fluid profile-picture ml-auto"
                  /></a>

                  <ul v-if="menuClicked" @click="menuClicked = !menuClicked">
                    <li class="px-3">
                      {{ $getTranslation("Welcome", $route.params.region) }},
                      {{ username }}
                    </li>
                    <li class="px-3">
                      <a :href="viewProfile" target="_blank">{{
                        $getTranslation("View Profile", $route.params.region)
                      }}</a>
                    </li>

                    <li class="px-3">
                      <a
                        href="#"
                        target="_blank"
                        v-on:click.prevent="checkSession"
                        >{{
                          $getTranslation("Logout", $route.params.region)
                        }}</a
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "utility",
  data() {
    return {
      active: "Product Support",
      items: [],
      map: {
        "product-support": "Product Support",
      },
      // showLinks: this.$store.state.showLinks,
      siteUrl: process.env.VUE_APP_API_ENDPOINT,
      username: "",
      technicalApproved: false,
      viewProfile: `${process.env.VUE_APP_ROCUI_ENDPOINT}/${
        this.$route.params.region
      }/dashboard`,
      data: [],
      menuClicked: false,
      msg: this.$getTranslation("Quality Assistant", this.$route.params.region),
      tooltipContent: "",
      usericon: "",
      siteRegion: "",
    };
  },
  created() {
    let arr = location.pathname.split("/").filter(function(e) {
        return e;
      }),
      product = {
        // name: "Product Support",
        // href: "/",
        // target: "_self",
      },
      site = arr[1];

    // is valid site, or 404
    let valid = ["sleep-apnea", "portable-oxygen", "ventilation"].some((e) => {
      return e === site;
    });

    if (arr.length && valid) {
      this.active = this.map[arr[1]];
      this.items = [
        covid19,
        { name: "Sleep Apnea", href: "/sleep-apnea/", target: "_self" },
        {
          name: "Portable Oxygen",
          href: "/portable-oxygen/",
          target: "_self",
        },
        { name: "Ventilation", href: "/ventilation/", target: "_self" },
        {
          name: "I’m a Healthcare Professional",
          href:
            "https://www.resmed.com/us/en/healthcare-professional.html?utm_source=rmd&utm_medium=b2c-website",
          target: "_self",
        },
      ];

      if (site === "sleep-apnea") {
        this.items.push(myair);
      }
    }
    // consumers index
    else {
      this.active = "Product Support";
      this.items = [product];
    }

    // Get top menu bar links
    const address = `${this.siteUrl}/${
      this.$route.params.region
    }/wp-json/resmed/v1/navigation/top-navigation`;

    axios.get(address).then((response) => {
      this.data = response.data;
    });
  },

  async mounted() {
    // console.log('store ',this.$store.state.siteLinks);
    // this.showLinks = sessionStorage.getItem("showLinks");
    this.username = $cookies.get("b2bFirstName");
    if (this.username === null) {
      this.checkCookie();
    }

    const role = $cookies.get("role");
    const categoryCookie = $cookies.get("categories");

    try {
      if (
        (categoryCookie == "" || categoryCookie == null) &&
        (role != "" || role != null)
      ) {
        this.$cookies.set(
          "categories",
          role && role.replace(/approved/g, "approve"),
          null,
          "/",
          window.location.hostname.includes(".resmed.com")
            ? ".resmed.com"
            : "localhost"
        );
      }
    } catch (error) {
      console.log(error);
    }
    const tEmail = $cookies.get("rocEmail");
    this.technicalApproved = role && role.includes("technical_approved");
    this.technicalEmail = tEmail && tEmail.toLowerCase().includes("@resmed.");
    if (this.username === null) {
      this.tooltipContent = this.$getTranslation(
        "Login Here",
        this.$route.params.region
      );
      this.usericon = "0";
      //  console.log(this.usericon);
    } else {
      this.tooltipContent = this.$getTranslation(
        "View Profile",
        this.$route.params.region
      );
      this.usericon = "1";
      //  console.log(this.usericon);
    }
    this.isUk();
  },

  watch: {
    "$root.isIdle": {
      handler() {
        console.log(this.$root);
        if (this.$root.isIdle) {
          console.log("idle");
          if ($cookies.get("b2bFirstName") !== null) {
            this.checkSession();
          }
        }
      },
    },
  },

  methods: {
    checkSession() {
      console.log("check session");
      window.location.reload();
      axios
        .get("https://resmed-ext-1.okta.com/api/v1/sessions/me", {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        })
        .then((response) => {
          if (response.data.id) {
            this.logout(response.data.id);
          } else {
            //If Id is not present in the response, clear cookies
            // console.log("check session");

            this.clearCookies();
          }
        })
        .catch((error) => {
          console.log("error", error);
          // If API returns error, clear cookies

          this.clearCookies();
        });
    },
    logout(sessionId) {
      axios
        .delete("https://b2baccounts.resmed.com/resmed-sso/v1/user/logout", {
          headers: {
            okta_sid: sessionId,
          },
        })
        .then((response) => {
          this.clearCookies();
        })
        .catch((error) => {
          // If API returns error, clear cookies
          console.log("Something went wrong", error);
        });
    },
    clearCookies() {
      const keys = $cookies.keys();
      if (keys.length) {
        keys.forEach((item) => {
          $cookies.remove(
            item,
            null,
            window.location.hostname === "localhost"
              ? "localhost"
              : "resmed.com"
          );
        });
      }
      // $cookies.remove("b2bFirstName", null, ".resmed.com");
      // $cookies.remove("role", null, ".resmed.com");
      // $cookies.remove("RegionCode", null, ".resmed.com");
      // $cookies.remove("redirectLoggedPath", null, ".resmed.com");
      // $cookies.remove("SoftwareURL", null, ".resmed.com");
      window.location.reload();
    },

    checkCookie() {
      window.setInterval(() => {
        if ($cookies.get("b2bFirstName") !== null) {
          console.log("cookie found");
          window.location.reload();
        }
      }, 5000);
    },

    redirectNotLoggedInUser() {
      window.open(
        `${
          process.env.VUE_APP_ROCUI_ENDPOINT
        }/${this.$route.params.region.replaceAll(
          "/",
          ""
        )}/signin?product-support&redirect_to=${this.$route.path}`,
        "_blank"
      );
    },
    ignorePhilips(item) {
      // console.log(this.$route.params);
      const hasSlug = this.$route.params.hasOwnProperty("slug");
      const hasArticle = this.$route.params.hasOwnProperty("article");
      // console.log(hasSlug);
      if (item.description === "philips-recall" && !hasSlug && !hasArticle) {
        // console.log(item.description, hasSlug);
        return true;
      } else if (
        item.description === "philips-recall" &&
        (hasSlug || hasArticle)
      ) {
        return false;
      } else {
        return true;
      }
    },

    // check the region
    isUk() {
      this.siteRegion = this.$route.params.region;
      return this.siteRegion;
    },
  },

  computed: {
    ...mapState(["showLinks"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.utility-black {
  background-color: $cc-resmed-dark-grey;
  // background-color: #b02543;
  .bg-red {
    background-color: #0d0a15;
    border-radius: 50rem !important;
    height: 38px;
  }

  .bg-red {
    background-color: #0d0a15;
    border-radius: 50rem !important;
    height: 38px;
  }

  .items {
    display: flex;
    justify-content: space-between;
    min-height: 3rem;
    line-height: 3rem;

    @extend %navigation;
    font-size: 0.875em;
    .back-link {
      min-width: 5%;
    }
    .prev {
      background-size: 0.825rem 0.825rem;
      background-repeat: no-repeat;
      // background-image: url(#{$assets}/images/icon-left-arrow-red.svg);
      padding-left: 1.5rem;
      transition: all 0.5s ease;
      background-position: left center;

      &:hover {
        // transform: translateX(-6px);
      }
    }
    ul.product-links {
      display: flex;
      // justify-content: center;
    }
    ul {
      list-style: none;
      margin: 0;

      li {
        // margin-right: 1rem;
        // padding: 0.69125rem 0 0.5rem 0;
        border-bottom: 3px solid transparent;

        &:hover,
        &:focus {
          // background:#ccc;
        }

        &.is-active {
          border-bottom: 3px solid #9d2872;
          // border-bottom: 3px solid $cc-resmed-action-red;
        }

        a {
          transition: opacity 0.5s;
          padding: 3px 5px;
          // padding:0.1rem 0.1rem;
          &:hover,
          &:focus {
            // opacity: 0.5;
            color: #fff;
            background: #cccccc2e;
            padding: 3px 5px;
            border-radius: 15px;
          }
        }
      }

      &.local {
        li {
          margin-right: 0;
        }
      }
    }

    a {
      color: $cc-resmed-white;

      &.country {
        padding: 0 0 0 1.5rem;

        background-size: 1rem 1rem;
        background-repeat: no-repeat;
        background-position: left center;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSI+ICAgIDxkZWZzPiAgICAgICAgPHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMTV2MTVIMHoiLz4gICAgPC9kZWZzPiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4gICAgICAgIDwvbWFzaz4gICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik05LjA0NCAxMy40MzJhMTEuMTI0IDExLjEyNCAwIDAgMCAxLjgyLTUuMjVoMi43MzNhNi4xNDYgNi4xNDYgMCAwIDEtNC41NTMgNS4yNXptLTcuNjQtNS4yNWgyLjczMWMuMTUzIDEuODgzLjc4IDMuNjg2IDEuODIxIDUuMjVhNi4xNDYgNi4xNDYgMCAwIDEtNC41NTItNS4yNXptNC41NTItNi42MTRhMTEuMTE3IDExLjExNyAwIDAgMC0xLjgyIDUuMjVIMS40MDVhNi4xNDYgNi4xNDYgMCAwIDEgNC41NTItNS4yNXptLS40NTkgNS4yNUE5LjczOCA5LjczOCAwIDAgMSA3LjUgMS43NGE5LjcyMyA5LjcyMyAwIDAgMSAyLjAwNSA1LjA4SDUuNDk3em0wIDEuMzY0aDQuMDA2QTkuNzM1IDkuNzM1IDAgMCAxIDcuNSAxMy4yNmE5LjczMyA5LjczMyAwIDAgMS0yLjAwNC01LjA4em04LjEtMS4zNjRoLTIuNzMyYTExLjEwMSAxMS4xMDEgMCAwIDAtMS44Mi01LjI1IDYuMTQ1IDYuMTQ1IDAgMCAxIDQuNTUyIDUuMjV6TTcuNSAwQzMuMzY1IDAgMCAzLjM2NCAwIDcuNSAwIDExLjYzNSAzLjM2NSAxNSA3LjUgMTVjNC4xMzYgMCA3LjUtMy4zNjUgNy41LTcuNUMxNSAzLjM2NCAxMS42MzYgMCA3LjUgMHoiIG1hc2s9InVybCgjYikiLz4gICAgPC9nPjwvc3ZnPg==);
      }
    }
  }
  .menu {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .profile-picture {
    width: 25px;
    margin-top: 0.75rem;
  }

  .menu a {
    display: block;
    color: #fff;
    text-decoration: none;
  }

  .menu li {
    display: block;
    float: left;
    position: relative;
    background: #222;
    // background-color: #b02543;
    color: #fff;
    margin-right: 0 !important; // }

    a {
      transition: opacity 0.5s;
      //  padding:3px 8px;
      // padding:0.1rem 0.1rem;
      &:hover,
      &:focus {
        opacity: 0.5;
        // color: #fff;
        background: none !important;
        // padding: 3px 8px;
        // border-radius: 15px;
      }
    }
  }

  .menu li ul {
    position: absolute;
    right: 5px;
    margin: 0;
    z-index: 1;
    padding: 0;
    top: 3rem;
  }

  .menu li ul li {
    background: #333;
    min-width: 11.25rem;
  }
}

.utility {
  background-color: $cc-resmed-dark-grey;
  // background-color: #b02543;

  .items {
    display: flex;
    justify-content: space-between;
    min-height: 3rem;
    line-height: 3rem;

    @extend %navigation;
    font-size: 0.875em;
    .back-link {
      min-width: 5%;
    }
    .prev {
      background-size: 0.825rem 0.825rem;
      background-repeat: no-repeat;
      // background-image: url(#{$assets}/images/icon-left-arrow-red.svg);
      padding-left: 1.5rem;
      transition: all 0.5s ease;
      background-position: left center;

      &:hover {
        transform: translateX(-6px);
      }
    }
    ul.product-links {
      display: flex;
      justify-content: center;
    }
    ul {
      list-style: none;
      margin: 0;

      li {
        // margin-right: 2.25rem;
        // padding: 0.69125rem 0 0.5rem 0;
        border-bottom: 3px solid transparent;

        &.is-active {
          border-bottom: 3px solid #9d2872;
          // border-bottom: 3px solid $cc-resmed-action-red;
        }

        a {
          transition: opacity 0.5s;
          //  padding:0.1rem 0.1rem;
          padding: 3px 8px;
          &:hover,
          &:focus {
            // opacity: 0.5;
            color: #fff;
            background: #cccccc2e;
            // background: none !important;
            padding: 3px 5px;
            border-radius: 15px;
          }
        }
      }

      &.local {
        li {
          margin-right: 0;
        }
      }
    }

    a {
      color: $cc-resmed-white;

      &.country {
        padding: 0 0 0 1.5rem;

        background-size: 1rem 1rem;
        background-repeat: no-repeat;
        background-position: left center;
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSI+ICAgIDxkZWZzPiAgICAgICAgPHBhdGggaWQ9ImEiIGQ9Ik0wIDBoMTV2MTVIMHoiLz4gICAgPC9kZWZzPiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4gICAgICAgIDwvbWFzaz4gICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik05LjA0NCAxMy40MzJhMTEuMTI0IDExLjEyNCAwIDAgMCAxLjgyLTUuMjVoMi43MzNhNi4xNDYgNi4xNDYgMCAwIDEtNC41NTMgNS4yNXptLTcuNjQtNS4yNWgyLjczMWMuMTUzIDEuODgzLjc4IDMuNjg2IDEuODIxIDUuMjVhNi4xNDYgNi4xNDYgMCAwIDEtNC41NTItNS4yNXptNC41NTItNi42MTRhMTEuMTE3IDExLjExNyAwIDAgMC0xLjgyIDUuMjVIMS40MDVhNi4xNDYgNi4xNDYgMCAwIDEgNC41NTItNS4yNXptLS40NTkgNS4yNUE5LjczOCA5LjczOCAwIDAgMSA3LjUgMS43NGE5LjcyMyA5LjcyMyAwIDAgMSAyLjAwNSA1LjA4SDUuNDk3em0wIDEuMzY0aDQuMDA2QTkuNzM1IDkuNzM1IDAgMCAxIDcuNSAxMy4yNmE5LjczMyA5LjczMyAwIDAgMS0yLjAwNC01LjA4em04LjEtMS4zNjRoLTIuNzMyYTExLjEwMSAxMS4xMDEgMCAwIDAtMS44Mi01LjI1IDYuMTQ1IDYuMTQ1IDAgMCAxIDQuNTUyIDUuMjV6TTcuNSAwQzMuMzY1IDAgMCAzLjM2NCAwIDcuNSAwIDExLjYzNSAzLjM2NSAxNSA3LjUgMTVjNC4xMzYgMCA3LjUtMy4zNjUgNy41LTcuNUMxNSAzLjM2NCAxMS42MzYgMCA3LjUgMHoiIG1hc2s9InVybCgjYikiLz4gICAgPC9nPjwvc3ZnPg==);
      }
    }
  }
  .menu {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .profile-picture {
    width: 25px;
    margin-top: 0.75rem;
  }

  .menu a {
    display: block;
    color: #fff;
    text-decoration: none;
  }

  .menu li {
    display: block;
    float: left;
    position: relative;
    background: #222;
    // background-color: #b02543;
    color: #fff;
    margin-right: 0 !important; // }

    a {
      transition: opacity 0.5s;
      //  padding:3px 8px;
      // padding:0.1rem 0.1rem;
      &:hover,
      &:focus {
        opacity: 0.5;
        // color: #fff;
        background: none !important;
        // padding: 3px 8px;
        // border-radius: 15px;
      }
    }
  }

  .menu li ul {
    position: absolute;
    right: 5px;
    margin: 0;
    z-index: 1;
    padding: 0;
    top: 3rem;
  }

  .menu li ul li {
    background: #333;
    min-width: 11.25rem;
  }
}
.product-links-wrapper {
  min-width: 75%;
}
.menu-wrapper {
  min-width: 10%;
  display: flex;
  justify-content: flex-end;
}

img.help-icon {
  width: 44px;
  position: relative;
  top: 6px;
  padding: 6px;
}
svg.home-icon {
  position: relative;
  top: 6px;
}
</style>

<style lang="scss">
// covid-19 (temp)
.navigation > .utility:not(.-default) {
  @media (min-width: 992px) and (max-width: 1199px) {
    li a > span {
      display: none;
    }
  }
}
// end

.tooltipQualityAssistant.tooltip {
  z-index: 102;
  background: #363636;
  color: #d1d1d1;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 5px;
  max-width: 250px;
}

.tooltipusericon.tooltip {
  z-index: 102;
  background: #363636;
  color: #d1d1d1;
  padding: 6px 14px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-top: 5px;
}

.tooltipHome {
  position: relative;
  display: inline-block;
  // border-bottom: 1px dotted black;
  padding: 0px;
}

.tooltipHome .tooltiptext {
  visibility: hidden;
  // width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  font-weight: 500;
  font-size: 10px;
  left: 50px;
  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}

.tooltipHome:hover .tooltiptext {
  visibility: visible;
}

.usericonli {
  background: none;
}
.usericonli > a {
  transition: opacity 0.5s;
  padding: 0.1rem 0.1rem;
  &:hover,
  &:focus {
    opacity: 0.5;
    background: none !important;
  }
}
.homeicon .home-icon {
  transition: opacity 0.5s;
  padding: 0.1rem 0.1rem;
  &:hover,
  &:focus {
    // opacity: 0.5;
    // color: #b02543;
    opacity: 0.5;
    background: none !important;
  }
}
.qualityiconli {
  background: none !important;

  &:hover,
  &:focus {
    background: none !important;
  }
}
.qualityicon .quality-icon {
  transition: opacity 0.5s;
  padding: 0.1rem 0.1rem;
  &:hover,
  &:focus {
    // opacity: 0.5;
    // color: #b02543;
    opacity: 0.5;
    background: none !important;
  }
}

.uk-only-link {
  background: #612f8c;
  border-radius: 50px;
  margin: 0 20px 0 12px !important;
}

.textlengthupdate {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  max-width: 18ch !important;
  display: block;
  color: white !important;

  &:hover {
    overflow: visible;
    text-overflow: visible;
    max-width: 27ch !important;
  }
}

// temporary fix
@media screen and (orientation: landscape) {
  .back-link.tooltipHome.homeicon,
  .product-links-wrapper ul {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  .menu-wrapper + ul:first-of-type {
    display: flex;
    align-items: center;
  }
}
</style>
